import React, { useState, useEffect } from "react";
import Scrollspy from "react-scrollspy";
import img from "../Img/splogo.PNG"
const Header = (props) => {  
  const [click, setClick] = useState(false);
  const handleClick = () => {
    setClick(!click);
  } 
  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 71) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener("scroll", changeBackground);

  return (
    <>
      <header className={navbar ? "main-header fixed-header" : "main-header"}>
        <nav className="">
          <div className="header-opacity">
            
            <button
              className="navbar-toggler"
              type="button"
              onClick={handleClick}
            >
              <div id="menuHamburger" className={click ? "hamburgerm active" : "hamburgerm"}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </button>
            {
              props.site.logoFilename === null ?
              <div>
              </div>
              :
              <img
                className="navbar-style"
                src={process.env.REACT_APP_API_SERVICE_BASE_URL + "image/" + "SiteLogoImages/" + props.site.logoFilename}
                alt=""
              />
            }

            <div
            id='menuHandler'
              className={
                click
                  ? "small-menu justify-content-end active"
                  : "small-menu justify-content-end"
              }
            >
              <div style={{display:"flex", justifyContent:"end"}}>
                            <button
              className="navbar-toggler"
              type="button"
              onClick={handleClick}
              style={{marginRight:"0.2rem", marginTop:"0.5rem"}}
            >
              <div id="menuHamburger" className={"hamburgerm active"}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </button>
            </div>
              <Scrollspy
                className="an navbar-top ml-auto"
                currentClassName="current"
                offset={-150}
              >
                <p className="powered-by-message" style={{marginBottom:"2rem"}}>menu</p>
                <li><a className="nav-link" href="#home" onClick={handleClick}><span>Home</span></a></li>
                {props.site.aboutUsPageEnabled ? <li><a className="nav-link" href="#about" onClick={handleClick}><span>About Us</span></a></li> : <></>}
                {props.site.servicePageEnabled ? <li><a className="nav-link"href="#services"onClick={handleClick}><span>Services</span></a></li> : <></>}
                {props.site.staffPageEnabled ? <li><a className="nav-link"href="#staff"onClick={handleClick}><span>Team</span></a></li> : <></>}
                <p className="powered-by-message" style={{position:"absolute", bottom:"40px"}}>Powered By ...</p>
              </Scrollspy>
              {/* <button
                className=" sidebar-bottom-closer"
                type="button"
                onClick={handleClick}
              >
                Close Sidebar
              </button> */}
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;
